import React from 'react';
import { IPE_UPLOAD_ACCEPT } from '@/utils/ipeImageUploadFormats';

/**
 * webkitdirectory 隐藏 input（showDirectoryPicker 不可用时的兜底）。
 */
export default function StudioFolderFileInput({
  inputRef,
  onChange,
  disabled = false,
  accept = IPE_UPLOAD_ACCEPT,
}) {
  return (
    // eslint-disable-next-line react/no-unknown-property -- webkitdirectory 用于文件夹选择
    <input
      ref={inputRef}
      type="file"
      accept={accept}
      multiple
      hidden
      disabled={disabled}
      webkitdirectory=""
      onChange={onChange}
    />
  );
}
